import { truncate } from 'lodash'

// See the documentation of lodash#truncate for more information.
export default (string, options = {}) =>
  truncate(string || '-', { length: 50, omission: '…', ...options })
